import styled from 'styled-components';

export const Container = styled.li`
  cursor: pointer;
  padding: 0 16px;
  background-color: ${({ theme }) => theme.expensesSelectableList.item.background};

  &:hover {
    background-color: ${({ theme }) => theme.expensesSelectableList.item.backgroundHover};
  }
`;

export const Content = styled.div`
  padding: 28px 0;
  border-top: 1px solid ${({ theme }) => theme.expensesSelectableList.item.division};
`;

export const Row = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Icon = styled.img`
  width: 24px;
  margin-right: 8px;
`;

export const Name = styled.span`
  flex: 1;
  padding: 4px 0;
  min-width: 100px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
  line-height: 18px;
  color: ${({ theme }) => theme.expensesSelectableList.item.primary};
`;

export const Value = styled.h5`
  font-weight: 600;
  margin-right: 8px;
  color: ${({ theme }) => theme.expensesSelectableList.item.secondary};
`;

export const Currency = styled.span`
  font-size: 12px;
  margin-right: 8px;
  color: ${({ theme }) => theme.expensesSelectableList.item.secondary};
`;

export const Arrow = styled.img`
  height: 32px;
`;

export const LogoRappi = styled.img`
  position: absolute;
  top: -4px;
  left: calc(24px + 8px);
  width: 24px;
`;
